import {Room} from "@/core/api/room.api";
import {roomService} from "@/core/service/room.service";
import {roomRecordApi} from "@/core/api/room.record.api";
import {BaseApi} from "@/core/api/base.api";

class PcAppApi extends BaseApi {

    userAgent;
    version;
    showLog = true;

    constructor() {
        super()
        Room.PcApp = this
        window.pcapp = this
        const THIS = this

        this.userAgent = navigator.userAgent
        const userAgentArr = this.userAgent.split(' ');
        const lastText = userAgentArr[userAgentArr.length-1]

        if(!lastText.startsWith('SkMySuniApp')) {
            return;
        }

        const textArr = lastText.split('/')
        this.version = textArr[1]
        this.setCallbackFunction();

        window.onbeforeunload = function (e) {
            THIS.recordStop()
        }

        Room.ready(async e => {
            this._eventListen(this.#Events)

            let info = Room.getRoomData();
            await roomService.roomRecordPcAppClient().then((res) => {
                let data = res.data;
                if (data.code !== 'RT_SUCCESS') {
                    throw 'server-error';
                }

                let server = data.data;
                let recordOptions = {
                    recordServer: server,
                    // timeSliceMs: 1000 * 1,
                    // sendChunksTermMs: 1,
                    // sendChunksLimit: 51200,
                    audioInput: (function () {
                        let status = info.me.micStatus;
                        if (status === 'none') {
                            return false;
                        }
                        return {
                            deviceId: '',
                            mute: status !== 'on'
                        };
                    }())
                }
                return this.recordStart(recordOptions);
            });
        })
    }


    #Events = {
        room_changeUserDeviceStatus: function(e) {
            const userId = e.data.userId;
            const deviceType = e.data.deviceType
            const deviceStatus = e.data.deviceStatus

            if (!Room.User.isMe(userId)) {
                return
            }
            if (deviceType === 'mic') {
                PcApp.changeAudioDevice(deviceStatus == true)
            }
        },
        room_changeUserDeviceStatusAll: function(e) {
            const deviceType = e.data.deviceType
            const deviceStatus = e.data.deviceStatus
            const roomUserList = Room.getRoomData().roomUserList;

            roomUserList.forEach(userId => {
                const roomUser = Room.User.getRoomUser(userId)
                if(Room.User.isMe(userId)) {
                    if (Room.User.hasSpeakerRole(roomUser)) {
                        if (deviceType === 'mic') {
                            PcApp.changeAudioDevice(deviceStatus == true)
                        }
                    }
                }
            })
        }
    }

    isPcApp() {
        return !!this.version;
    }

    sendMsg(data) {
        console.log('# PC-APP send msg ', data || data.api);
        window.apisend(encodeURIComponent(JSON.stringify(data)));
    }

    setCallbackFunction() {
        const functionName = 'fromMySuniOnPcApp';
        window[functionName] = data => {
            this.fromMySuniOnPcApp(data);
        }
        this.sendMsg(        {
            api: '/app/setCallbackFunction',
            data: {
                functionName
            }
        })
    }

    recordStart(options) {
        const audio = roomRecordApi.userDevice.audio;
        const deviceId = audio.deviceId;
        const groupId = audio.groupId;
        let label = audio.label;

        if (deviceId == 'default' || deviceId == 'communications'){
            navigator.mediaDevices.enumerateDevices().then(devices=> {
                devices.forEach(device => {
                    if (device.kind == 'audioinput' && device.groupId == groupId && !(device.deviceId == 'default' || device.deviceId == 'communications')) {
                        // console.log('###############', groupId, " / ", device.groupId)
                        // console.log('############### send', device.deviceId, '/', device.label);
                        label = device.label
                    }
                });

                this.sendMsg({
                    api: '/room/record/start',
                    data: {
                        audio: {
                            deviceId: label,
                            status: roomRecordApi.userDevice.micStatus
                        },
                        record: {
                            type: 'http', // ws, http
                            serverUrl: options.recordServer
                        }
                    }
                });
            });
        }
    }

    recordStop() {
        this.sendMsg({
            api: '/room/record/stop'
        });
    }

    changeAudioDevice(deviceStatus) {
        const audio = roomRecordApi.userDevice.audio;
        const groupId = audio.groupId;
        let label = audio.label;

        navigator.mediaDevices.enumerateDevices().then(devices=> {
            devices.forEach(device => {
                // if (device.kind == 'audioinput') {
                //     console.log('############# 목록', devices)
                //     console.log('############# 현재', groupId)
                // }
                if (device.kind == 'audioinput' && device.groupId == groupId && !(device.deviceId == 'default' || device.deviceId == 'communications')) {
                    // console.log('###############', groupId, " / ", device.groupId)
                    // console.log('############### send', device.deviceId, '/', device.label);
                    label = device.label
                }
            });

            this.sendMsg({
                api: '/room/record/changeAudioDevice',
                data: {
                    deviceId: label,
                    status: !!deviceStatus || roomRecordApi.userDevice.micStatus
                }
            })
        });
    }

    close() {
        this.sendMsg({
            api: '/app/close'
        })
    }

    appUpdate() {
        this.sendMsg({
            api: '/app/update',
            data: {
                version: '1.0.0.2',
                downloadUrl: 'https://www.yoondisk.co.kr/mysuni/exe/mySuniOn_install.exe'
            }
        })
    }

    fromMySuniOnPcApp(data) {
        if (this.showLog) {
            console.log('# PC-APP callback ',data.data.audio);
            // console.log('# PC-APP callback record ',data.data.record);
            // console.log('# PC-APP callback upload ',data.data.upload);
        }
    }
}

export const PcApp = new PcAppApi()
